import { Component, Renderer2, Inject, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import { DatePipe } from '@angular/common';
import { DOCUMENT } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AnalyticsHelper } from 'src/app/helpers/analytics';
import Swal from 'sweetalert2';
import { debug } from 'console';
@Component({
  selector: 'sale-performance',
  templateUrl: './sale-performance.component.html',
  styleUrls: ['./sale-performance.component.scss']
})
export class SalePerformanceComponent implements OnChanges {
  @Output() ready = new EventEmitter<boolean>();
  @Input() selectedDate: any;
  @Input() monthlyData: any;
  mtdSaleChannels: any;
  vmbuSaleChannels: any;
  executionSaleChannels: any;
  strategicSaleChannels: any;
  retailSalesDivisionTotalChannels: any;
  alcoholChannels: any;
  eCommerceChannels: any;
  retailCompanyTotal: any;

  foodServiceCompanys: any;
  channels: any;

  constructor(public datepipe: DatePipe, private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private http: HttpClient) { }

  /**
   * Creates an empty channel object with the standard structure
   */
  private createEmptyChannelObject(name: string, imp: number = 0, backgroundTotal: boolean = false): any {
    return {
      name,
      imp,
      backgroundTotal,
      bapc: { act: 0, ly: 0, bp: 0, st: 0, vsLy: 0, vsBp: 0, vsSt: 0 },
      nsr: { act: 0, ly: 0, bp: 0, st: 0, vsLy: 0, vsBp: 0, vsSt: 0 },
      nsrPerCase: { act: 0, ly: 0, bp: 0, st: 0, vsLy: 0, vsBp: 0, vsSt: 0 },
      gp: { act: 0, ly: 0, bp: 0, st: 0, vsLy: 0, vsBp: 0, vsSt: 0 },
      gpPerCase: { act: 0, ly: 0, st: 0, bp: 0, vsLy: 0, vsBp: 0, vsSt: 0 }
    };
  }

  /**
   * Accumulates row data into a channel object
   */
  private accumulateRowData(channel: any, row: any): void {
    channel.bapc.act += parseFloat(row.bapc_ty);
    channel.bapc.ly += parseFloat(row.bapc_ly);
    //ecommerce là channel = 331, 332 và region code = 9200 và district code = 9230
    //cvs hq là channel code != 411 và region code = 7100
    if (row.regionCode == '9999') {
      channel.bapc.bp += parseFloat(row.bapc_bp);
    }
    else {
      channel.bapc.st += parseFloat(row.bapc_bp);
    }
    channel.nsr.act += parseFloat(row.nsr_ty);
    channel.nsr.ly += parseFloat(row.nsr_ly);
    if (row.regionCode == '9999') {
      channel.nsr.bp += parseFloat(row.nsr_bp);
    }
    else {
      channel.nsr.st += parseFloat(row.nsr_bp);
    }
    channel.gp.act += parseFloat(row.gp_ty);
    channel.gp.ly += parseFloat(row.gp_ly);
    if (row.regionCode == '9999') {
      channel.gp.bp += parseFloat(row.gp_bp);
    }
    else {
      channel.gp.st += parseFloat(row.gp_bp);
    }
  }
  private accumulateRowDataByDivision(channel: any, row: any): void {
    channel.bapc.act += parseFloat(row.bapc_ty);
    channel.bapc.ly += parseFloat(row.bapc_ly);
    //ecommerce là channel = 331, 332 và region code = 9200 và district code = 9230
    //cvs hq là channel code != 411 và region code = 7100
    if (row.regionCode != '9999') {
      channel.bapc.st += parseFloat(row.bapc_bp);
    }
    channel.nsr.act += parseFloat(row.nsr_ty);
    channel.nsr.ly += parseFloat(row.nsr_ly);
    if (row.regionCode != '9999') {
      channel.nsr.st += parseFloat(row.nsr_bp);
    }
    channel.gp.act += parseFloat(row.gp_ty);
    channel.gp.ly += parseFloat(row.gp_ly);
    if (row.regionCode != '9999') {
      channel.gp.st += parseFloat(row.gp_bp);
    }
  }


  private accumulateRowDataCoreBizz(channel: any, row: any): void {
    channel.bapc.act += parseFloat(row.bapc_ty);
    channel.bapc.ly += parseFloat(row.bapc_ly);
    //ecommerce là channel = 331, 332 và region code = 9200 và district code = 9230
    //cvs hq là channel code != 411 và region code = 7100
    if ((row.regionCode == '9999' && row.channelCode != '511')) {
      channel.bapc.bp += parseFloat(row.bapc_bp);
    }
    else if (row.channelCode != '511') {
      channel.bapc.st += parseFloat(row.bapc_bp);
    }
    channel.nsr.act += parseFloat(row.nsr_ty);
    channel.nsr.ly += parseFloat(row.nsr_ly);
    if (row.regionCode == '9999' && row.channelCode != '511') {
      channel.nsr.bp += parseFloat(row.nsr_bp);
    }
    else if (row.channelCode != '511') {
      channel.nsr.st += parseFloat(row.nsr_bp);
    }
    channel.gp.act += parseFloat(row.gp_ty);
    channel.gp.ly += parseFloat(row.gp_ly);
    if (row.regionCode == '9999' && row.channelCode != '511') {
      channel.gp.bp += parseFloat(row.gp_bp);
    }
    else if (row.channelCode != '511') {
      channel.gp.st += parseFloat(row.gp_bp);
    }
  }

  private accumulateRowData9999(channel: any, row: any, type: any = 0): void {
    channel.bapc.act += parseFloat(row.bapc_ty);
    channel.bapc.ly += parseFloat(row.bapc_ly);
    //ecommerce là channel = 331, 332 và region code = 9200 và district code = 9230
    //cvs hq là channel code != 411 và region code = 7100
    if ((row.regionCode == '9999')) {
      channel.bapc.bp += parseFloat(row.bapc_bp);
    }
    else {
      channel.bapc.st += parseFloat(row.bapc_bp);
    }
    channel.nsr.act += parseFloat(row.nsr_ty);
    channel.nsr.ly += parseFloat(row.nsr_ly);
    if (row.regionCode == '9999') {
      channel.nsr.bp += parseFloat(row.nsr_bp);
    }
    else {
      channel.nsr.st += parseFloat(row.nsr_bp);
    }
    channel.gp.act += parseFloat(row.gp_ty);
    channel.gp.ly += parseFloat(row.gp_ly);
    if (row.regionCode == '9999') {
      channel.gp.bp += parseFloat(row.gp_bp);
    }
    else {
      channel.gp.st += parseFloat(row.gp_bp);
    }
  }

  /**
   * Processes and formats channels: calculates percentages, per-case values, and formats numbers
   */
  private processAndFormatChannels(channels: any[], totalChannel?: any): void {
    for (let i = 0; i < channels.length; i++) {
      const channel = channels[i];

      // Calculate percentages
      channel.bapc.vsSt = AnalyticsHelper.percent(channel.bapc.act, channel.bapc.st);
      channel.bapc.vsBp = AnalyticsHelper.percent(channel.bapc.act, channel.bapc.bp);
      channel.bapc.vsLy = AnalyticsHelper.percent(channel.bapc.act, channel.bapc.ly);
      channel.nsr.vsSt = AnalyticsHelper.percent(channel.nsr.act, channel.nsr.st);
      channel.nsr.vsBp = AnalyticsHelper.percent(channel.nsr.act, channel.nsr.bp);
      channel.nsr.vsLy = AnalyticsHelper.percent(channel.nsr.act, channel.nsr.ly);
      channel.gp.vsSt = AnalyticsHelper.percent(channel.gp.act, channel.gp.st);
      channel.gp.vsBp = AnalyticsHelper.percent(channel.gp.act, channel.gp.bp);
      channel.gp.vsLy = AnalyticsHelper.percent(channel.gp.act, channel.gp.ly);

      // Calculate per-case values
      channel.nsrPerCase = AnalyticsHelper.calcPerCase(channel.nsr, channel.bapc);
      channel.nsrPerCase.act = Math.round(channel.nsrPerCase.act / 1000);
      channel.nsrPerCase.measure = Math.round(channel.nsrPerCase.measure / 1000);
      channel.gpPerCase = AnalyticsHelper.calcPerCase(channel.gp, channel.bapc);
      channel.gpPerCase.act = Math.round(channel.gpPerCase.act / 1000);
      channel.gpPerCase.measure = Math.round(channel.gpPerCase.measure / 1000);

      // Calculate importance percentage (before formatting nsr values)
      if (i > 0) {
        const totalNsr = totalChannel ? totalChannel.nsr.act : channels[0].nsr.act;
        // FPT-HoiLT2: [2022/10/25][SENSE][1203212320245909] SENSE daily report issues
        channel.imp = parseFloat((channel.nsr.act * 100 / 1000000 / totalNsr).toFixed(1));
      }

      // Format values
      channel.bapc.act = Math.round(channel.bapc.act / 1000);
      channel.bapc.ly = Math.round(channel.bapc.ly / 1000);
      channel.bapc.bp = Math.round(channel.bapc.bp / 1000);
      channel.nsr.act = Math.round(channel.nsr.act / 1000000);
      channel.nsr.ly = Math.round(channel.nsr.ly / 1000000);
      channel.nsr.bp = Math.round(channel.nsr.bp / 1000000);
      channel.gp.act = Math.round(channel.gp.act / 1000000);
      channel.gp.ly = Math.round(channel.gp.ly / 1000000);
      channel.gp.bp = Math.round(channel.gp.bp / 1000000);
    }
  }

  /**
   * Gets the selected month as a string in yyyyMM format
   */
  private getSelectedMonth(): string {
    const selectedDate = new Date(this.selectedDate.year, this.selectedDate.month - 1, this.selectedDate.day);
    return this.datepipe.transform(selectedDate, "yyyyMM");
  }

  ngOnChanges() {
    //Init data performance
    if (this.monthlyData != null && this.selectedDate != null) {
      this.handleMtdSaleChannels();
      this.handleVmbuSaleChannels();
      this.handleExecutionSaleChannels();
      this.handleStrategicSaleChannels();
      this.handleRetailCompanyTotal();
      this.handleFoodServiceCompany();
      this.handleChannels();
      let t = this;
      setTimeout(() => {
        t.ready.emit(true);
      });
    }
  }

  handleChannels() {
    this.strategicSaleChannels.splice(1, 1);
    this.channels = [...this.retailCompanyTotal, ...this.vmbuSaleChannels, ...this.executionSaleChannels, ...this.retailSalesDivisionTotalChannels, ...this.strategicSaleChannels, ...this.eCommerceChannels, ...this.alcoholChannels];
  }

  handleMtdSaleChannels() {
    this.mtdSaleChannels = [];
    this.mtdSaleChannels.push(this.createEmptyChannelObject('Total incl. Alc', 100));
    this.mtdSaleChannels.push(this.createEmptyChannelObject('Core Biz', 0));

    const channels = AnalyticsHelper.ChannelLv22026();
    for (let i = 0; i < channels.length; i++) {
      const channel = channels[i];
      if (channel.channel.indexOf('Vending') == 0 && channel.level > 1) {
        continue;
      }
      this.mtdSaleChannels.push(this.createEmptyChannelObject(channel.channel, 0));
    }
    this.mtdSaleChannels.push(this.createEmptyChannelObject('Alcohol', 0));

    const month = this.getSelectedMonth();
    for (let i = 0; i < this.monthlyData.length; i++) {
      const row = this.monthlyData[i];
      if (row.month != month) {
        continue;
      }

      const channelCode = row.channelCode.substring(0, 2);
      const matchChannels = channels.filter(x => x.code.find(y => y == channelCode));

      for (let j = 0; j < matchChannels.length; j++) {

        const channel = this.mtdSaleChannels.find(x => x.name == matchChannels[j].channel);
        if (channel == null || row.regionCode == '7200' || (row.regionCode == '9100' && row.channelCode == '511')) {
          continue;
        }
        this.accumulateRowData(channel, row);
      }

      // Alcohol
      //if (row.regionCode == '7200' || (row.regionCode == '9100' && row.channelCode == '511')) {
      if (row.regionCode == '7200' || (row.regionCode == '9100' && row.channelCode == '511') || (row.regionCode == '9999' && row.channelCode == '511')) {
        const alcoholChannel = this.mtdSaleChannels[this.mtdSaleChannels.length - 1];
        this.accumulateRowData(alcoholChannel, row);
      } else {
        // Core biz
        const coreBizChannel = this.mtdSaleChannels[1];
        this.accumulateRowDataCoreBizz(coreBizChannel, row);
      }

      // Total
      this.accumulateRowData9999(this.mtdSaleChannels[0], row);
    }

    this.processAndFormatChannels(this.mtdSaleChannels);
  }


  handleVmbuSaleChannels() {
    this.vmbuSaleChannels = [];
    this.vmbuSaleChannels.push(this.createEmptyChannelObject('VMBU Total', 100, true));

    const channels = AnalyticsHelper.Branches();
    for (let i = 0; i < channels.length; i++) {
      this.vmbuSaleChannels.push(this.createEmptyChannelObject(channels[i].name, 0));
    }

    const month = this.getSelectedMonth();
    for (let i = 0; i < this.monthlyData.length; i++) {
      const row = this.monthlyData[i];
      // FPT-HoiLT2: [20230118]SENSE Issue mismatch QC
      if (row.channelCode == 411 || row.channelCode == 511 || row.month != month ||
        !channels.some((x) => x.districtCode.some(y => y == row.districtCode)) ||
        !channels.some((x) => x.regionCode == row.regionCode)) {
        continue;
      }

      const matchChannel = channels.find(x => x.regionCode == row.regionCode && x.districtCode.some(y => y == row.districtCode));
      if (matchChannel != null) {
        const channel = this.vmbuSaleChannels.find(x => x.name == matchChannel.name);
        if (channel != null) {
          // FPT-HoiLT2: [20230118]SENSE Issue mismatch QC
          if (!['132', '331', '332', '411', '511'].includes(row.channelCode)) {
            this.accumulateRowDataByDivision(channel, row);
          }
        }
      }

      if (row.regionCode != '9100') {
        this.accumulateRowDataByDivision(this.vmbuSaleChannels[0], row);
      }
    }

    this.processAndFormatChannels(this.vmbuSaleChannels);
  }

  handleExecutionSaleChannels() {
    this.executionSaleChannels = [];
    this.executionSaleChannels.push(this.createEmptyChannelObject('National Sales Division Total', 100, true));

    const channels = AnalyticsHelper.Regions();
    for (let i = 0; i < channels.length; i++) {
      this.executionSaleChannels.push(this.createEmptyChannelObject(channels[i].name, 0));
    }

    const month = this.getSelectedMonth();
    for (let i = 0; i < this.monthlyData.length; i++) {
      const row = this.monthlyData[i];
      if (row.channelCode == 411 || row.channelCode == 511 || row.month != month ||
        !channels.some((x) => x.code == row.regionCode)) {
        continue;
      }

      const matchChannel = channels.find(x => x.code == row.regionCode);
      if (matchChannel != null) {
        const channel = this.executionSaleChannels.find(x => x.name == matchChannel.name);
        if (channel != null) {
          this.accumulateRowDataByDivision(channel, row);
        }
      }

      this.accumulateRowDataByDivision(this.executionSaleChannels[0], row);
    }

    this.processAndFormatChannels(this.executionSaleChannels);
  }

  handleStrategicSaleChannels() {
    this.strategicSaleChannels = [];
    this.retailSalesDivisionTotalChannels = [];
    this.alcoholChannels = [];
    this.eCommerceChannels = [];

    this.strategicSaleChannels.push(this.createEmptyChannelObject('CVS Sales HQ Total', 100, true));
    this.retailSalesDivisionTotalChannels.push(this.createEmptyChannelObject('Retail Sales Division Total', 100, true));

    const channels = AnalyticsHelper.retailSaleDivisionChannel();
    const channelsForCustomerDevelopmentTotal = AnalyticsHelper.ChannelLv3ForCustomerDevelopmentTotal();
    const eCommerceSalesTotalChannel = AnalyticsHelper.eCommerceSalesTotal();

    for (let i = 0; i < eCommerceSalesTotalChannel.length; i++) {
      this.eCommerceChannels.push(this.createEmptyChannelObject(eCommerceSalesTotalChannel[i].channel, 100, true));
    }

    for (let i = 0; i < channels.length; i++) {
      this.retailSalesDivisionTotalChannels.push(this.createEmptyChannelObject(channels[i].channel, 0));
    }

    this.alcoholChannels.push(this.createEmptyChannelObject('Alcohol Sales Total', 0, true));
    const alcoholChannels = AnalyticsHelper.alcoholChannel();
    for (let i = 0; i < alcoholChannels.length; i++) {
      this.alcoholChannels.push(this.createEmptyChannelObject(alcoholChannels[i].channel, 0));
    }

    for (let i = 0; i < channelsForCustomerDevelopmentTotal.length; i++) {
      this.strategicSaleChannels.push(this.createEmptyChannelObject(channelsForCustomerDevelopmentTotal[i].channel, 0));
    }
    const month = this.getSelectedMonth();
    for (let i = 0; i < this.monthlyData.length; i++) {
      const row = this.monthlyData[i];
      if (row.month != month) {
        continue;
      }

      const matchChannels = channels.filter(x => x.districtCode == row.districtCode);
      const matchChannelsForCustomerDevelopmentTotal = channelsForCustomerDevelopmentTotal.filter(x => x.code.find(y => y == row.channelCode));
      const matchAlcoholChannel = alcoholChannels.filter(x => x.code.find(y => y == row.channelCode) && x.districtCode == row.districtCode);
      const eCommerceChannels = eCommerceSalesTotalChannel.filter(x => x.code.find(y => y == row.channelCode));

      for (let j = 0; j < matchChannels.length; j++) {
        const channel = this.retailSalesDivisionTotalChannels.find(x => x.name == matchChannels[j].channel);
        if (row.channelCode == 411 || row.channelCode == 511 || channel == null ||
          row.regionCode == '7200' || row.regionCode == '9100') {
          continue;
        }
        if (row.regionCode == '9300') {
          this.accumulateRowDataByDivision(channel, row);
        }
      }

      for (let j = 0; j < matchChannelsForCustomerDevelopmentTotal.length; j++) {
        const channel = this.strategicSaleChannels.find(x => x.name == matchChannelsForCustomerDevelopmentTotal[j].channel);
        if (row.channelCode == 411 || row.channelCode == 511 || channel == null ||
          row.regionCode == '7200' || row.regionCode == '9100') {
          continue;
        }
        this.accumulateRowDataByDivision(channel, row);
      }

      for (let j = 0; j < matchAlcoholChannel.length; j++) {
        const channel = this.alcoholChannels.find(x => x.name == matchAlcoholChannel[j].channel);
        this.accumulateRowDataByDivision(channel, row);
      }

      for (let j = 0; j < eCommerceChannels.length; j++) {
        const channel = this.eCommerceChannels.find(x => x.name == eCommerceChannels[j].channel);
        this.accumulateRowDataByDivision(channel, row);
      }

      // Alcohol
      if (row.channelCode == '411' && row.regionCode == '7200') {
        this.accumulateRowDataByDivision(this.alcoholChannels[0], row);
      }

      if (matchChannels.length > 0 && row.regionCode == '9300') {
        this.accumulateRowDataByDivision(this.retailSalesDivisionTotalChannels[0], row);
      }

      if (matchChannelsForCustomerDevelopmentTotal.length > 0 && row.regionCode != '9100') {
        this.accumulateRowDataByDivision(this.strategicSaleChannels[0], row);
      }
    }

    this.processAndFormatChannels(this.retailSalesDivisionTotalChannels);
    this.processAndFormatChannels(this.strategicSaleChannels);
    this.processAndFormatChannels(this.eCommerceChannels);
    // Special handling for alcohol channels
    for (let i = 0; i < this.alcoholChannels.length; i++) {
      const channel = this.alcoholChannels[i];
      channel.bapc.vsSt = AnalyticsHelper.percent(channel.bapc.act, channel.bapc.st);
      channel.bapc.vsBp = AnalyticsHelper.percent(channel.bapc.act, channel.bapc.bp);
      channel.bapc.vsLy = AnalyticsHelper.percent(channel.bapc.act, channel.bapc.ly);
      channel.nsr.vsSt = AnalyticsHelper.percent(channel.nsr.act, channel.nsr.st);
      channel.nsr.vsBp = AnalyticsHelper.percent(channel.nsr.act, channel.nsr.bp);
      channel.nsr.vsLy = AnalyticsHelper.percent(channel.nsr.act, channel.nsr.ly);
      channel.nsrPerCase = AnalyticsHelper.calcPerCase(channel.nsr, channel.bapc);
      channel.nsrPerCase.act = Math.round(channel.nsrPerCase.act / 1000);
      channel.nsrPerCase.measure = Math.round(channel.nsrPerCase.measure / 1000);
      channel.gp.vsSt = AnalyticsHelper.percent(channel.gp.act, channel.gp.st);
      channel.gp.vsBp = AnalyticsHelper.percent(channel.gp.act, channel.gp.bp);
      channel.gp.vsLy = AnalyticsHelper.percent(channel.gp.act, channel.gp.ly);
      channel.gpPerCase = AnalyticsHelper.calcPerCase(channel.gp, channel.bapc);
      channel.gpPerCase.act = Math.round(channel.gpPerCase.act / 1000);
      channel.gpPerCase.measure = Math.round(channel.gpPerCase.measure / 1000);

      if (i == 0) {
        channel.imp = 100;
      }
      else if (i > 0) {
        channel.imp = parseFloat((channel.nsr.act * 100 / 1000000 / this.alcoholChannels[0].nsr.act).toFixed(1));
      }

      channel.bapc.act = Math.round(channel.bapc.act / 1000);
      channel.bapc.ly = Math.round(channel.bapc.ly / 1000);
      channel.bapc.bp = Math.round(channel.bapc.bp / 1000);
      channel.nsr.act = Math.round(channel.nsr.act / 1000000);
      channel.nsr.ly = Math.round(channel.nsr.ly / 1000000);
      channel.nsr.bp = Math.round(channel.nsr.bp / 1000000);
      channel.gp.act = Math.round(channel.gp.act / 1000000);
      channel.gp.ly = Math.round(channel.gp.ly / 1000000);
      channel.gp.bp = Math.round(channel.gp.bp / 1000000);
    }
  }

  handleRetailCompanyTotal() {
    this.retailCompanyTotal = [];
    this.retailCompanyTotal.push(this.createEmptyChannelObject('Total', 100, true));
    const month = this.getSelectedMonth();
    for (let i = 0; i < this.monthlyData.length; i++) {
      const row = this.monthlyData[i];
      if (row.month != month || row.regionCode == '5000' || row.regionCode == '9100'
        || row.regionCode == '1120' || row.regionCode == '5160' || row.regionCode == '5100' || row.regionCode == '9400'
      ) {
        continue;
      }
      this.accumulateRowDataByDivision(this.retailCompanyTotal[0], row);
    }

    this.processAndFormatChannels(this.retailCompanyTotal);
  }

  handleFoodServiceCompany() {
    this.foodServiceCompanys = [];
    this.foodServiceCompanys.push(
      this.createEmptyChannelObject('Total', 100, true)
    );

    this.foodServiceCompanys.push(this.createEmptyChannelObject('FS Area Sales Total', 100, true));


    const channels = AnalyticsHelper.FoodBranches();
    for (let i = 0; i < channels.length; i++) {
      if (i == (channels.length - 1)) {
        this.foodServiceCompanys.push(this.createEmptyChannelObject(channels[i].name, 0, true));
      } else {
        this.foodServiceCompanys.push(this.createEmptyChannelObject(channels[i].name, 0));
      }


    }


    const month = this.getSelectedMonth();
    for (let i = 0; i < this.monthlyData.length; i++) {
      const row = this.monthlyData[i];
      if (row.channelCode == 411 || row.channelCode == 511 || row.month != month ||
        (!channels.some((x) => x.code == row.districtCode) && (row.regionCode !== '5000' && row.regionCode !== '9400'))) {
        continue;
      }

      const matchChannel = channels.find(x => x.code == row.districtCode);
      if (matchChannel != null) {
        const channel = this.foodServiceCompanys.find(x => x.name == matchChannel.name);
        if (channel != null) {
          this.accumulateRowDataByDivision(channel, row);
        }
      }
      //calculate for FS Area Sales Total
      if (row.regionCode !== '9400') {
        this.accumulateRowDataByDivision(this.foodServiceCompanys[1], row);
      }
      //calculate for Total
      this.accumulateRowDataByDivision(this.foodServiceCompanys[0], row);
    }

    this.processAndFormatChannels(this.foodServiceCompanys);
  }


  formatNumber(number: any) {
    return AnalyticsHelper.formatNumber(number);
  }
  /**
   * @author FPT-HoiLT2
   * @Desciption [2022/10/25][SENSE][1203212320245909] SENSE daily report issues
   */
  formatPercent(number: any) {
    return AnalyticsHelper.formatPercent(number);
  }
  /**
   * @author FPT-HoiLT2
   * @Desciption [2022/10/25][SENSE][1203212320245909] SENSE daily report issues
   */
  isChannelLv2(channelName: string) {
    return AnalyticsHelper.ChannelLv2().some((obj) => obj.channel === channelName && obj.level === 2 && channelName != 'Retail' && channelName != 'Food');
  }
  /**
   * @author FPT-HoiLT2
   * @Desciption [2022/10/25][SENSE][1203212320245909] SENSE daily report issues
   */
  isVMBUSalesLv2(branchName: string) {
    return AnalyticsHelper.Branches().some((obj) => obj.name === branchName);
  }
}
